import { render, staticRenderFns } from "./ReferralPromotionCreateAndUpdateFormItems.vue?vue&type=template&id=61797304&"
import script from "./ReferralPromotionCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"
export * from "./ReferralPromotionCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61797304')) {
      api.createRecord('61797304', component.options)
    } else {
      api.reload('61797304', component.options)
    }
    module.hot.accept("./ReferralPromotionCreateAndUpdateFormItems.vue?vue&type=template&id=61797304&", function () {
      api.rerender('61797304', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ReferralPromotionCreateAndUpdateFormItems.vue"
export default component.exports